/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExtractionRowData } from '../definitions';

const row: ConversationExtractionRowData = {
  icon: 'circle-filled',
  title: 'Unknown Freshdesk source', // eslint-disable-line @intercom/intercom/no-bare-strings
};

export default row;
